import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LL } from 'i18n/i18n.service';
import { CsCardInterfaceClass, CsCardComponent } from 'components/cs-card/cs-card';
import { AuthService } from 'services/auth.service';
import { TelemetryService } from 'services/telemetry.service';
import { AlertController } from 'providers/alert-controller';
import { ToastController } from 'providers/toast-controller';
import { presentSupportContactAsync } from 'utils/support-contact';
import { TranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-support-card',
  templateUrl: 'cs-support-card.html',
  host: { 'class': 'support-card' },
  providers: [{ provide: CsCardInterfaceClass, useExisting: CsSupportCardComponent }],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsSupportCardComponent extends CsCardInterfaceClass implements AfterViewInit {
  protected LL = LL;
  @Input() description?: TranslatedString;
  @ViewChild(CsCardComponent) card: CsCardComponent;

  constructor(
    elemRef: ElementRef,
    private auth: AuthService,
    private telemetry: TelemetryService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
  ) {
    super(elemRef);
  }

  ngAfterViewInit(): void {
    if (this.card) {
      this.card.updateLayout();
    }
  }

  override updateLayout(): void {
    if (this.card) {
      this.card.updateLayout();
    }
  }

  override getCurrentCardHeight(): number {
    return this.card ? this.card.getCurrentCardHeight() : 0;
  }

  override getCardElement(): HTMLElement {
    return this.elemRef.nativeElement;
  }

  async handleEmailSupportClick() {
    this.telemetry.trackEvent('support_card_email_support_clicked', {});
    // show a dialog with the support address instead of a bare "mailto:" navigation,
    // which is silently swallowed on a desktop with no default mail client (#3830)
    await presentSupportContactAsync(this.alertCtrl, this.toastCtrl, this.auth.user.email);
  }
}
